import { uniqueBy } from '@debbie/common/dist/util/index.js'
import { SocketUser } from '@debbie/common/dist/web-sockets/index.js'
import { h } from '@debbie/cortex/dist/index.js'
import { useMe } from '@debbie/cortex/dist/me/index.js'
import { RootState } from '@debbie/cortex/dist/reducer.js'
import { useTenantId } from '@debbie/cortex/dist/tenant/index.js'
import { MenuItem, UserPreview } from '@debbie/iris/dist/components/index.js'
import React from 'react'
import { useSelector } from 'react-redux'
import { styled } from 'styled-components'

const ActiveUsersOnCase = (props: { id: string }) => {
  const meLoadable = useMe()
  const me = h.hasData(meLoadable) ? meLoadable.data : null
  const tenantId = useTenantId()
  const activeUsers: {
    [tenantId: string]: SocketUser[]
  } = useSelector((s: RootState) => s.activeUsers)

  const usersOnCase = React.useMemo(() => {
    if (!tenantId || !me) {
      return null
    }
    let users: SocketUser[] = []
    const tenantActiveUsers = activeUsers[tenantId] as SocketUser[] | undefined
    if (tenantActiveUsers) {
      users = [
        ...users,
        ...tenantActiveUsers.filter(
          (user: SocketUser) =>
            user.activities.some((a) => a.handle == props.id) &&
            user.id !== me.id,
        ),
      ]
    }
    return users.length > 0 ? uniqueBy(users, (u: SocketUser) => u.id) : users
  }, [tenantId, me, activeUsers, props.id])

  const filteredUsersOnCase =
    usersOnCase &&
    usersOnCase.filter((user: SocketUser) => !user.details.isSystemAgent)

  return filteredUsersOnCase && filteredUsersOnCase.length > 0 ? (
    <MenuItem>
      <div>
        {filteredUsersOnCase.map((user) => (
          <ActiveUser key={user.id}>
            <UserPreview
              user={{
                id: user.id,
                firstName: user.firstName,
                lastName: user.lastName,
                role: user.role,
              }}
            />
          </ActiveUser>
        ))}
      </div>
    </MenuItem>
  ) : null
}

export default ActiveUsersOnCase

const ActiveUser = styled.div`
  display: inline-block;
  position: relative;

  .active-user-tooltips {
    position: absolute;
    bottom: 21px;
    left: -5px;
    min-width: 100px;

    .typing-indicator {
      margin-top: 5px;
    }

    .case-preview {
      margin-top: 5px;
      font-size: 0.5em;
    }
  }
`
